import React from "react";
import { Redirect } from "react-router";

import Loading from "scenes/Loading";
import Emitter from "services/Emitter";
import AuthService from "services/AuthService";

class SSORedirect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            authenticated: false,
        };
    }

    componentDidMount() {
        if (!AuthService.isAuthenticating()) {
            AuthService.reauth();
            return;
        }

        Emitter.on("LOGGED_IN", () => {
            this.setState({ loading: false, authenticated: true });
            AuthService.clearRedirectUrl();
        });
    }

    componentWillUnmount() {
        Emitter.off("LOGGED_IN");
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }
        const url = this.state.authenticated
            ? AuthService.redirectUrl() || "/"
            : "/forbidden";
        return <Redirect push to={url} />;
    }
}

export default SSORedirect;
